import TitleLayout from '@/components/Layout/TitleLayout';
import TabbedContainer from '@/components/TabbedContainer';
import React from 'react';
import { useParams } from 'react-router-dom';
import { LicensesForm } from '../components/LicensesForm';
import { OrganizationForm } from '../components/OrganizationForm';
import { SsoConnectionForm } from '../components/SsoConnectionForm';

export const ManageOrganizationPage = () => {
  const params = useParams();
  const { organizationId } = params;

  const tabs = [
    { name: 'Edit', content: <OrganizationForm organizationId={organizationId} /> },
    {
      name: 'Single Sign On',
      content: <SsoConnectionForm organizationId={organizationId} />,
    },
    {
      name: 'Licenses',
      content: (
        <div className="mt-6 space-y-2 divide-y divide-y-blue-gray-200">
          <div className="flex-col justify-between">
            <h2 className="text-xl font-medium text-blue-gray-900">Licenses</h2>
            <p className="text-sm text-slate-700 pt-1">Manage licenses for this organization</p>
          </div>

          <div className="pt-3">
            {organizationId && <LicensesForm organizationId={organizationId} />}
          </div>
        </div>
      ),
    },
  ];

  return (
    <TitleLayout title={`Edit Organization`}>
      <div className="block">
        <div className="border-b border-gray-200">
          <TabbedContainer tabs={tabs} />
        </div>
      </div>
    </TitleLayout>
  );
};
